module.exports = __webpack_public_path__ + "img/swice.af4bbe19.png";